"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../../shared/helpers");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const SuggestionsAndLinksModal_1 = __importDefault(require("./SuggestionsAndLinksModal"));
const react_i18next_1 = require("react-i18next");
const SuggestionsAndLinksStyles_1 = require("./styles/SuggestionsAndLinksStyles");
const MobileStyles_1 = require("./styles/MobileStyles");
const SuggestionsAndLinks = (props) => {
    const [modalIsOpen, setModalIsOpen] = (0, react_1.useState)(false);
    const [modalViewType, setModalViewType] = (0, react_1.useState)(null);
    const [modalTitle, setModalTitle] = (0, react_1.useState)(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const permissions = (0, react_1.useMemo)(() => ({
        suggestions: helpers_1.Permissao.busca(13),
        comments: helpers_1.Permissao.busca(12),
        hasIcap: helpers_1.Permissao.tem(57),
        hasRedePergamum: helpers_1.Permissao.tem(87),
    }), []);
    const handleOnClickSuggestion = (viewType, description) => {
        setModalViewType(viewType);
        setModalTitle(description);
        setModalIsOpen(true);
    };
    return (react_1.default.createElement("div", { className: 'secaoBtnMobileLink' },
        react_1.default.createElement(MobileStyles_1.MobileButtonOrganizer, null,
            permissions.comments ? (react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'btn-generic--segundo ml-0', onClick: () => handleOnClickSuggestion('C', permissions.comments.descricao) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['far', 'comment-dots'], className: "r5" }),
                permissions.comments.descricao)) : '',
            permissions.suggestions ? (react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'btn-generic--segundo ml-0', onClick: () => handleOnClickSuggestion('S', permissions.suggestions.descricao) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "shopping-bag", className: "r5" }),
                permissions.suggestions.descricao)) : '',
            permissions.hasIcap ? (react_1.default.createElement(MobileStyles_1.MobileLink, { rel: "noopener noreferrer", className: 'btn-generic--segundo ml-0', target: "_blank", href: "https://www.pergamum.pucpr.br/artigos_compartilhados/index.php?resolution2=1024" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "database", className: "r5" }),
                "Pergamum Artigos Compartilhados")) : '',
            permissions.hasRedePergamum ? (react_1.default.createElement(MobileStyles_1.MobileLink, { rel: "noopener noreferrer", className: 'btn-generic--segundo ml-0', target: "_blank", href: "https://www.pergamum.pucpr.br/redepergamum/consultas/site_CRP/pesquisa.php" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "database", className: "r5" }),
                t('CatalogoRedePergamum'))) : ''),
        react_1.default.createElement(SuggestionsAndLinksModal_1.default, { title: modalTitle, isOpen: modalIsOpen, setIsOpen: setModalIsOpen, viewType: modalViewType })));
    return (react_1.default.createElement("div", { className: "container text-center pad20 preto80" },
        react_1.default.createElement(SuggestionsAndLinksModal_1.default, { title: modalTitle, isOpen: modalIsOpen, setIsOpen: setModalIsOpen, viewType: modalViewType }),
        react_1.default.createElement("div", { className: "d-flex flex-column justify-content-center", style: { gap: '8px' } },
            permissions.comments ? (react_1.default.createElement(SuggestionsAndLinksStyles_1.SuggestionsAndLinksButton, { onClick: () => handleOnClickSuggestion('C', permissions.comments.descricao) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['far', 'comment-dots'], className: "r5" }),
                permissions.comments.descricao)) : '',
            permissions.suggestions ? (react_1.default.createElement(SuggestionsAndLinksStyles_1.SuggestionsAndLinksButton, { onClick: () => handleOnClickSuggestion('S', permissions.suggestions.descricao) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "shopping-bag", className: "r5" }),
                permissions.suggestions.descricao)) : '',
            permissions.hasIcap ? (react_1.default.createElement(SuggestionsAndLinksStyles_1.SuggestionsAndLinksLink, { rel: "noopener noreferrer", target: "_blank", href: "https://www.pergamum.pucpr.br/icap" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "database", className: "r5" }),
                "ICAP")) : '',
            permissions.hasRedePergamum ? (react_1.default.createElement(SuggestionsAndLinksStyles_1.SuggestionsAndLinksLink, { rel: "noopener noreferrer", target: "_blank", href: "https://www.pergamum.pucpr.br/redepergamum/consultas/site_CRP/pesquisa.php" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "database", className: "r5" }),
                t('CatalogoRedePergamum'))) : '')));
};
exports.default = SuggestionsAndLinks;
